import React from 'react';
import { OTPInput, SlotProps, REGEXP_ONLY_DIGITS } from 'input-otp';
import { cn } from '@/utils/cn';
import { Title3 } from '@pensionbee/honeypot-ui';

interface OtpInputProps {
  value?: string;
  onChange?: (value: string) => void;
  onComplete?: (value: string) => void;
  maxLength?: number;
  disabled?: boolean;
  error?: boolean;
  className?: string;
}

function Slot(props: SlotProps & { error?: boolean }) {
  return (
    <div
      className={`flex h-[45px] w-[45px] xs:h-[52px] xs:w-[52px] p-16 justfify-center items-center mr-4 border-r-8 border-2 bg-grey-8 rounded-8 text-center ${
        props.error
          ? 'border-red-100'
          : props.isActive
            ? 'border-grey-2'
            : 'border-grey-3'
      }`}
    >
      {props.char !== null && (
        <Title3 className="block w-full text-center pl-2">{props.char}</Title3>
      )}
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  );
}

function FakeCaret() {
  return (
    <div className="absolute pointer-events-none inset-0 flex items-center justify-center animate-caret-blink">
      <div className="w-px h-8 bg-gray-800" />
    </div>
  );
}

const OtpInput: React.FC<OtpInputProps> = ({
  value = '',
  onChange,
  onComplete,
  maxLength = 6,
  disabled = false,
  error = false,
  className,
}) => {
  const handleChange = (value: string) => {
    onChange?.(value);
  };

  const handleComplete = (value: string) => {
    onComplete?.(value);
  };

  return (
    <div className={cn('w-full', className)}>
      <OTPInput
        value={value}
        onChange={handleChange}
        inputMode="numeric"
        pattern={REGEXP_ONLY_DIGITS}
        onComplete={handleComplete}
        maxLength={maxLength}
        disabled={disabled}
        containerClassName="group flex items-center justify-start has-[:disabled]:opacity-30"
        render={({ slots }) => (
          <div className="flex items-center gap-2 p-4 bg-gray-50 rounded-lg">
            <div className="flex">
              {slots.map((slot, idx) => (
                <Slot key={idx} {...slot} error={error} />
              ))}
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default OtpInput;
